/**
 * Little wrapper to enable the naked select on target inputs.
 */
class SelectsNakedEnabler extends DrupalBehavior {
  onReady(document) {
    nakedFormSelect('.enable-naked-select-single');
  }

  onContent(context) {
    nakedFormSelect('.enable-naked-selects select');
    nakedFormSelect('.enable-naked-select');
    nakedFormSelect('.enable-naked-select-with-search', {
      keywordSearch: {
        on: true,
        placeholder: ''
      }
    });
  }

}

(function ($) {
  $.fn.updateNakedSelect = function () {
    nakedFormSelect ('.update-naked-selects select');
  };
})(jQuery);

DrupalBehavior.register('camc', 'SelectsNakedEnabler', SelectsNakedEnabler);
